import { Directive, HostBinding, Optional, Self } from '@angular/core';
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms';

@Directive({
  selector: '[formControlName], [formControl], [ngModel]',
})
export class RequiredFieldFeedbackDirective {
  constructor(
    @Self() @Optional() private readonly ngControl: NgControl,
    @Optional() private readonly formGroup: FormGroupDirective,
    @Optional() private readonly ngForm: NgForm
  ) {}

  @HostBinding('class.al-required-missing')
  get requiredMissing(): boolean {
    const control = this.ngControl?.control;

    if (!control || control.disabled || !control.hasError('required')) {
      return false;
    }

    return (
      control.touched ||
      this.formGroup?.submitted === true ||
      this.ngForm?.submitted === true
    );
  }
}
